var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaign",
    transform: "translate(-2563 -2674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_160",
    "data-name": "Union 160",
    d: "M17082.3-1568.275a6.168,6.168,0,0,1-1.908-2.467,9.164,9.164,0,0,1-.7-2.724h1.9c.15.558.27,1.107.441,1.634a4.031,4.031,0,0,0,1.061,1.69.5.5,0,0,1,.158.51c-.086.36-.141.729-.219,1.09-.059.275-.191.418-.371.418A.631.631,0,0,1,17082.3-1568.275Zm8.76-2.128c-1.381-.849-2.758-1.712-4.16-2.522a14.488,14.488,0,0,0-3.9-1.544c-.193-.043-.236-.129-.236-.313q.009-2.9,0-5.8c0-.12-.008-.219.156-.266a24.719,24.719,0,0,0,5.545-2.587c.867-.493,1.764-.939,2.621-1.441a1.107,1.107,0,0,1,1.588,1c-.021,2.085,0,4.174,0,6.263,0,2.068,0,4.14,0,6.212a1.071,1.071,0,0,1-.609,1.038,1,1,0,0,1-.471.127A.986.986,0,0,1,17091.061-1570.4Zm-12.053-4.247a2.779,2.779,0,0,1-.566-.056,3.019,3.019,0,0,1-2.441-2.99,2.967,2.967,0,0,1,2.656-2.934c.965-.086,1.938-.017,2.959-.017v6C17080.723-1574.645,17079.865-1574.645,17079.008-1574.649Z",
    transform: "translate(-14507.236 4265.751)",
    fill: "#1b1c1d",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9153",
    "data-name": "Rectangle 9153",
    width: 28,
    height: 28,
    transform: "translate(2563 2674)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.2ad5a5dfaf2946011a4cf76d27ee1c95.svg";
export { ForwardRef as ReactComponent };